
const number = {};

/**
 * Test si la valeur transmise ne contient que des chiffres, virgules, points, espaces
 **/
number.is_number = function(value) {
	const re = /^[\s\-]*\d[\d\s\.,]*$/;
	return re.test(value);
};

/**
 * Transforme une chaine de caractère en nombre
 **/
number.clean = function(str) {
	if (str && _.isString(str)) {
		var n = str.toString();

		n = _.replace(n, " ", "");
		n = _.replace(n, "€", "");
		n = _.replace(n, "%", "");
		n = _.replace(n, ",", ".");
		n = _.replace(n, "/", "");
		n = _.replace(n, "m²", "");
		// n = _.replace(n, '-', '')
		// n = _.trim(n)

		n = parseFloat(n);
		if (_.isNaN(n)) return 0;
		return n;
	}
	return str;
};


/**
 * Format un nombre (séparateur de millier + décimal en virgule)
 **/
number.format = function(n, decimal) {
	if (n) {
		var str = number.clean(n);
		if (str) {
			if (decimal) str = str.toFixed(decimal);
			else str = Math.round(str);
			
			str = str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
			str = str.replace(/\./g,",");
			if (!str) str = "0";
			if (n == "-1") return "-";
		}
		return str;
	}
	return n;
};


/**
 * Format un nombre (séparateur de millier) sans décimales
 **/
number.round = function(n) {
	if (n) {
		var str = Math.round(number.clean(n));
		str = str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
		str = str.replace(/\./g,",");
		if (!str) str = "0";
		if (n == "-1") return "-";
		return str;
	}
	return n;
};

/**
 * transforme une string en valeur entière en gérant les NaN
 */
number.to_int = function (value) {
	if (typeof(value) == "string" && value.trim() == "-") {
		return value;
	}
	const v = parseInt(value);
	if (isNaN(v)) {
		return "-";
	}
	return v;
};

/**
 * transforme une string en nombre décimal
 */
number.to_float = function (value) {
	let v = value;
	if (typeof (v) == "string") {
		v = v.replace(",", ".");
		v = parseFloat(v);
	}
	return v;
};

/**
 * transforme un nombre décimal en string avec %
 */
number.percent = function (value) {
	if (!value) return "";
	if (typeof (value) != "number") return value;
	const new_value = Math.round(value * 100);
	return `${new_value} %`;
};

/**
 * transforme une valeur en prix avec € comme suffixe
 * séparateur de millier est l'espace
 */
number.euro = function (value) {
	if (!value) return "";
	let v = parseInt(value);
	if (isNaN(v)) return "-";
	// if (typeof (v) != "number") return value;

	let s = String(v);
	let new_value = "";
	while (s.length > 3) {
		new_value += " " + s.substr(s.length - 3);
		s = s.substr(0, s.length - 3);
	}
	new_value = s + new_value;
	new_value = new_value.trim() + " €";
	return new_value;
},


number.pv = function(rate, periods, payment, future, type) {
	// Initialize type
	var type = (typeof type === "undefined") ? 0 : type;

	// Evaluate rate and periods (TODO: replace with secure expression evaluator)
	rate = eval(rate);
	periods = eval(periods);

	// Return present value
	if (rate === 0) {
		return - payment * periods - future;
	} else {
		return -(((1 - Math.pow(1 + rate, periods)) / rate) * payment * (1 +rate * type) - future) / Math.pow(1 + rate, periods);
	}
};


export default number;